import selectHideSenderImageOption from '../actions/selectHideSenderImageOption';
import SenderImageOptionState from '../store/schema/SenderImageOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
// import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';

export interface SenderImageFullProps {
    optionStore?: SenderImageOptionState;
}

@reactive({
    optionStore: () => store,
})
export default class SenderImageFull extends React.Component<SenderImageFullProps, {}> {
    render() {
        let { optionStore } = this.props;

        let showSenderImageInListView = getFallbackValueIfNull(
            optionStore.showSenderImageInListView,
            !getIsBitSet(ListViewBitFlagsMasks.HideSenderImage)
        );

        return (
            <ChoiceGroup
                selectedKey={`${showSenderImageInListView}`}
                options={[
                    {
                        key: 'true',
                        text: strings.options_messageList_showSenderImage,
                    },
                    {
                        key: 'false',
                        text: strings.options_messageList_hideSenderImage,
                    },
                ]}
                onChange={this.onHideSenderImageChange}
                label={strings.options_messageList_senderImageLabel}
            />
        );
    }

    private onHideSenderImageChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectHideSenderImageOption(option.key === 'true');
    };
}
